/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React, { Component } from 'react';
import style from '../../component/common/style/index.scss';
import assessmentConfig, { convertColumndef, convertRowData } from '../../common/tableConfig/studentAssessmentConfig';
import gridConfig from '../../common/tableConfig/gridConfig';
import asyncCallHandler from '../../common/utils/asyncCallHandler'
import { formatDateUrl } from '../../common/utils/index'
import AssessmentTable from './AssessmentTable';
import EDW_CONST from '../../common/constants';
import { EdwLoaderWithContainer } from '../common/edwLoaderWithContainer/EdwLoaderWithContainer'
import { ErrorData } from "../common/noData/NoData";

export class StudentAssessment extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            coloumnDef: [],
             rowData: [],
              icons: [],
               defaultColDef: [],
                height: props.height,
                assessmentConfig: assessmentConfig, 
                  defaultColumns: [],
                   customColumn: [],
                    viewBy:'indicativeGradeValue',
                    isDataFetch:false,
                    onCallback: props.onCallback,
                    isApiFail:false
                };
        
        this.iesToken = props.token ? props.token : ''
      }
     componentDidMount() {
          this.setState({ icons: gridConfig.icons,defaultColDef: gridConfig.defaultColDef });
          this.fetchQuestionAnalysis();
    } 

     componentDidUpdate(prevProps) {
         if(prevProps.groupId !== this.props.groupId || this.props.courseId !== prevProps.courseId){
            this.fetchQuestionAnalysis();
         }
          
    } 

    fetchQuestionAnalysis(){
        let assessmentData = { ...this.state.assessmentConfig}
        this.setState({ isDataFetch: false});
        let { studentId, groupId, schoolId, courseId} = this.props;
        asyncCallHandler(EDW_CONST.STUDENT_END_POINT, `studentAssessmentList?studentId=${studentId}&schoolId=${schoolId}&groupId=${groupId}&courseId=${courseId}`, this.iesToken).then(response => {
           
            assessmentData["icons"] = gridConfig.icons; 
            assessmentData['rowData'] = response.data;  
            this.generateGridConfig(assessmentData, this.state.viewBy);           
        }).catch((error) => {
            console.log("axios error:", error);
            this.setState({ isApiFail:true})
        }); 
       
    }
    generateGridConfig(assessmentConfig, viewBy) { 
         let columndef = convertColumndef(viewBy, assessmentConfig);
         let rowData = convertRowData(assessmentConfig);
         this.setState({ rowData: rowData, coloumnDef: columndef, isDataFetch: true, assessmentConfig: assessmentConfig });
         this.props.updateExportData({ type: "student_widget_2", rowData: rowData,columnDefs:this.state.coloumnDef});
     }

    onCellClick=(event) =>{  
        this.state.onCallback(event);
    }
     
  
    tableView(tableConfig){
       return <AssessmentTable {...tableConfig} />;
    }
  
    
    
    render() {
        let tableConfig={
            assessmentConfig:this.state.assessmentConfig,
            height:this.state.height,
            viewBy:this.state.viewBy,
            rowData: this.state.rowData,
            coloumnDef:this.state.coloumnDef,
            onCellClick: this.onCellClick,
            courseName:this.props.courseName,
            updateExportData: this.props.updateExportData    
        }
        let loadView = <div className="edw-full-width"><EdwLoaderWithContainer /></div>
        
        return (
            <div>
                <label><span className="card-title">Assessments</span></label>
                
                <div className="question-table">
                  
                    {(this.state.isDataFetch && !this.state.isApiFail) ? (this.tableView(tableConfig)) : (!this.state.isDataFetch && !this.state.isApiFail)? loadView:<ErrorData/>}                                                                                         
                </div>
               
           
            </div>

        )
    }
}





